import ListOfDutyPoints from './ListOfDutyPoints/ListOfDutyPoints';

export default ListOfDutyPoints;
